import React from "react";
import { StyledLink } from "../../../styled-mui";
import { SxProps, Theme } from "@mui/material";

interface SmartLinkProps {
  to: string;
  extraProps?: Record<string, any>;
  isExternal?: boolean;
  onClick?: () => any;
  children: React.ReactNode | React.ReactNode[];
  styles?: React.CSSProperties;
  className?: string;
  sx?: SxProps<Theme>;
  target?: "_blank" | "_self" | "_parent" | "_top" | "framename";
}

/**
 * This component handles redirecting of internal links and external links
 */
const SmartLink: React.FC<SmartLinkProps> = ({
  to,
  extraProps,
  isExternal = false,
  onClick,
  children,
  styles = {},
  className = "",
  target,
}) =>
  isExternal ? (
    <a
      href={to}
      target={target || "_blank"}
      rel="noopener noreferrer"
      style={styles}
      onClick={() => onClick && onClick()}
      className={className}
      {...extraProps}>
      {children}
    </a>
  ) : (
    <StyledLink to={to} style={styles} className={className} onClick={() => onClick && onClick()} {...extraProps}>
      {children}
    </StyledLink>
  );

export default SmartLink;
